// Import styles
import './styles/index.css';

// Import React
import React from 'react';
import ReactDOM from 'react-dom/client';

// Import components
import ChatWidget, { ChatWidgetProps } from './components/ChatWidget';
import ChatContainer from './components/ChatContainer';
import ChatMessage from './components/ChatMessage';
import ChatInput from './components/ChatInput';

// Import context
import { ChatProvider, useChatContext } from './context/ChatContext';

// Import types
import { 
  Message,
  MessageRole,
  ChatWidgetConfig,
  SendMessageOptions
} from './types';

// Export all components
export {
  ChatWidget,
  ChatContainer,
  ChatMessage,
  ChatInput,
  ChatProvider,
  useChatContext
};

// Export types
export type {
  Message,
  MessageRole,
  ChatWidgetConfig,
  ChatWidgetProps,
  SendMessageOptions
};

/**
 * Browser initialization function
 * This allows the chat widget to be initialized from plain JavaScript
 */
export const initChat = (config: ChatWidgetProps): void => {
  // Create container if it doesn't exist
  let container = document.getElementById('llm-studio-chat-container');
  if (!container) {
    container = document.createElement('div');
    container.id = 'llm-studio-chat-container';
    document.body.appendChild(container);
  }
  
  // Render chat widget
  const root = ReactDOM.createRoot(container);
  root.render(
    React.createElement(ChatWidget, config)
  );
};

// Create the API object
const LLMStudioChat = { init: initChat };

// Export as default for bundlers
export default LLMStudioChat;

// Add to global window object for UMD builds
if (typeof window !== 'undefined') {
  // Directly assign to window object to ensure it's available globally
  (window as any).LLMStudioChat = LLMStudioChat;
} 